import React from "react";
import { Stack, TextField, FormControlLabel, Switch, MenuItem } from "@mui/material";

const QuestionFormVideo = ({ value, onChange }) => {
    const v = value || {};

    return (
        <Stack spacing={2}>
            <TextField
                label="type"
                value={"video"}
                fullWidth
                select
                disabled
            >
                <MenuItem value="video">video</MenuItem>
            </TextField>

            <TextField
                label="subtitle"
                value={v.subtitle || ""}
                onChange={(e) => onChange({ ...v, subtitle: e.target.value })}
                fullWidth
            />

            <TextField
                label="addClass"
                value={v.addClass || ""}
                onChange={(e) => onChange({ ...v, addClass: e.target.value })}
                placeholder="horizontal"
                fullWidth
            />

            <TextField
                label="videoPath"
                value={v.videoPath || ""}
                onChange={(e) => onChange({ ...v, videoPath: e.target.value })}
                placeholder="https://www.youtube.com/embed/..."
                fullWidth
            />

            <FormControlLabel
                control={
                    <Switch
                        checked={Boolean(v.shouldGoNext)}
                        onChange={(e) => onChange({ ...v, shouldGoNext: e.target.checked })}
                    />
                }
                label="shouldGoNext"
            />

            <FormControlLabel
                control={
                    <Switch
                        checked={Boolean(v.isCreativeTask)}
                        onChange={(e) => onChange({ ...v, isCreativeTask: e.target.checked })}
                    />
                }
                label="isCreativeTask"
            />

            <TextField
                label="question (HTML)"
                value={v.question || ""}
                onChange={(e) => onChange({ ...v, question: e.target.value })}
                fullWidth
                multiline
                minRows={6}
            />
        </Stack>
    );
};

export default QuestionFormVideo;
